module.exports = __webpack_public_path__ + "385f7c04ed7bebb0edda110e9fe41102.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/crossmark_steward_funds.png
// module id = 1647
// module chunks = 0